import React from 'react';
import { ButtonLabel, ButtonsDiv, Container, Content, Divider, SelectArea } from './styles';
import Button from 'components/Buttom/Button';
import { useHistory } from 'react-router';

const HandleTrade = (): JSX.Element => {
  const history = useHistory();
  const path = window.location.pathname;
  return (
    <Container>
      <Content>
        <SelectArea>
          <h2>Selecione o que gostaria de acordo com seu tipo de perfil:</h2>
          <ButtonsDiv>
            <ButtonLabel>
              <Button
                text={'CRIAR NOVA CONTA'}
                onClick={() => {
                  if (path.includes('trade')) {
                    history.push('/signup/admin', { profile: 3 });
                  }
                }}
              />
              <label htmlFor="">Criação de novo usuário Trade</label>
            </ButtonLabel>
            <Divider />
            <ButtonLabel>
              <Button
                text={'ACESSAR MINHA CONTA'}
                onClick={() => {
                  if (path.includes('trade')) {
                    history.push('/login/admin', { profile: 3 });
                  }
                }}
              />
              <label htmlFor="">Acesse sua conta, histórico ou painel de cadastro</label>
            </ButtonLabel>
          </ButtonsDiv>
        </SelectArea>
      </Content>
    </Container>
  );
};

export default HandleTrade;
